<template>
	<div class="flex-grow-auto flex-column">
		<div v-if="!disabled && !code" class="app-scan flex-grow flex-column flex-center">
			<i class="app-scan-icon tf">&#xe661;</i>
			<p class="app-scan-message">请扫描{{name}}</p>
			<div class="app-scan-button flex-center" @click="scanHandle"><i class="tf-scan"></i>开始扫码</div>
		</div>
		<slot v-else></slot>
	</div>
</template>

<script>
	export default {
		name: 'scan',

		props: {
			name: {
				type: String,
				default: '产品背贴码'
			},
			immediate: {
				type: Boolean,
				default: true
			},
			disabled: Boolean,
			testData: [String, Object]
		},

		data() {
			return {
				code: ''
			}
		},

		mounted() {
			if (!this.disabled && this.immediate) {
				this.scanHandle();
			}
		},

		methods: {
			scanHandle() {
				if (this.testData) {
					this.code = this.testData;
					this.$emit('scan', this.testData);
				} else {
					this.scanCode({
						success: data => {
							this.code = data;
							this.$emit('scan', data);
						}
					});
				}
			},

			reset() {
				this.code = '';
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.app-scan {
		gap: .28rem;
		height: 100%;

		&-icon {
			font-size: 1.08rem;
			color: #ccc;
		}

		&-message {
			font-size: .28rem;
			color: #ccc;
		}

		&-button {
			gap: .22rem;
			width: 4.8rem;
			height: .88rem;
			border-radius: .44rem;
			font-size: .36rem;
			color: #fff;
			background: linear-gradient(90deg, #3D5EFF, #0078FF);
			box-shadow: 0 .04rem .1rem 0 rgba(61,94,255,.3);

			.tf {
				font-size: .4rem;
			}
		}
	}
</style>
